export default {
  state: {
    transportFlow_eventNode: '',
    insurance_checked_artwork: [],
    set_transportFlow_historyNode: [],
    set_transportFlow_opsLink: '', // 线下运维
    set_transportFlow_times: {},
    set_is_type: '',
    set_is_ex_ware_house: ''
  },
  actions: {// 在action中可以进行异步操作，外部用dispatch()调用
    set_transportFlow_eventNode ({commit, state}, param) {
      commit('set_transportFlow_eventNode', param)
    },
    set_insurance_checked_artwork ({commit, state}, param) {
      commit('set_insurance_checked_artwork', param)
    },
    set_transportFlow_historyNode ({commit, state}, param) {
      commit('set_transportFlow_historyNode', param)
    },
    set_transportFlow_opsLink ({commit, state}, param) {
      commit('set_transportFlow_opsLink', param)
    },
    // 流程基本信息开始结束时间
    set_transportFlow_times ({commit, state}, param) {
      commit('set_transportFlow_times', param)
    },
    // 流程——单个/批量
    set_is_type ({commit, state}, param) {
      commit('set_is_type', param)
    },
    // 是否出库(运输)
    set_is_ex_ware_house ({commit, state}, param) {
      commit('set_is_ex_ware_house', param)
    },
  },
  getters: {// 获取state里面的数据
    change_transportFlow_eventNode (state) {
      return state.transportFlow_eventNode
    },
    change_set_insurance_checked_artwork (state) {
      return state.insurance_checked_artwork
    },
  },
  mutations: {// 不要在mutations里面进行异步操作，外部用commit()调用
    set_insurance_checked_artwork (state, action) {
      state.insurance_checked_artwork = action
    },
    set_transportFlow_eventNode (state, action) {
      state.transportFlow_eventNode = action
    },
    set_transportFlow_historyNode (state, action) {
      state.set_transportFlow_historyNode = action
    },
    set_transportFlow_opsLink (state, action) {
      state.set_transportFlow_opsLink = action
    },
    set_transportFlow_times (state, action) {
      state.set_transportFlow_times = action
    },
    set_is_type (state, action) {
      state.set_is_type = action
    },
    set_is_ex_ware_house (state, action) {
      state.set_is_ex_ware_house = action
    },

  }
}



// WEBPACK FOOTER //
// ./src/store/devOpsManage/index.js